import React from 'react';
import LoginContainer from '../containers/LoginContainer';

export default function RouteLogin({ history }){ 
  return <LoginContainer history={history} />
}